// extracted by mini-css-extract-plugin
export default {"external":"acVyRZ","deprecatedBorderRadius":"bcVyRZ","hasAnimation":"ccVyRZ","container":"dcVyRZ"};